import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";import graphql from 'babel-plugin-relay/macro'
import {useFragment} from 'react-relay'
import useAtmosphere from '~/hooks/useAtmosphere'

import PrimaryButton from '../../../../components/PrimaryButton'
import useMutationProps from '../../../../hooks/useMutationProps'
import RemoveIntegrationProviderMutation from '../../../../mutations/RemoveIntegrationProviderMutation'
import {Dialog} from '../../../../ui/Dialog/Dialog'
import {DialogContent} from '../../../../ui/Dialog/DialogContent'
import {DialogTitle} from '../../../../ui/Dialog/DialogTitle'







const prettifyService = (service) => {
  switch (service) {
    case 'gitlab':
      return 'GitLab'
    case 'github':
      return 'GitHub'
    default:
      return service.charAt(0).toUpperCase() + service.slice(1)
  }
}

const RemoveIntegrationProviderDialog = (props) => {
  const atmosphere = useAtmosphere()
  const {isOpen, onClose, integrationProviderRef} = props
  const integrationProvider = useFragment(
    graphql`
      fragment RemoveIntegrationProviderDialog_integrationProvider on IntegrationProvider {
        id
        service
        ... on IntegrationProviderOAuth2 {
          serverBaseUrl
        }
      }
    `,
    integrationProviderRef
  )
  const {id: providerId, service, serverBaseUrl} = integrationProvider
  const {onCompleted, onError} = useMutationProps()

  const handleClick = () => {
    onClose()
    RemoveIntegrationProviderMutation(atmosphere, {providerId}, {onCompleted, onError})
  }
  const prettyService = prettifyService(service)
  return (
    _jsx(Dialog, { isOpen: isOpen, onClose: onClose, children: 
      _jsxs(DialogContent, { children: [
        _jsx(DialogTitle, { className: "flex items-center" , children: "Are you sure?"  })
        , _jsxs('div', { className: "pt-6 pb-2" , children: ["If you remove this"
             , ' '
          , _jsxs('b', { children: [
            prettyService
            , serverBaseUrl && ` (${serverBaseUrl.replace(/https:\/\//, '')})`
          ]}), ' ', "integration, it will no longer be available to any teams."

        ]})
        , _jsx('div', { className: "flex justify-end pt-6"  , children: 
          _jsxs(PrimaryButton, { type: "submit", onClick: handleClick, children: ["Remove "
             , prettyService, " integration"
          ]})
        })
      ]})
    })
  )
}

export default RemoveIntegrationProviderDialog
